<template>
  <el-cascader v-bind="$attrs"
               v-on="$listeners"
               :options="options"
               :filterable="true"
               :props="{ expandTrigger: 'hover' }">
  </el-cascader>
</template>

<script>
export default {
  name: 'WarehouseSelect',
  props: {
    selectAll: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.$store.dispatch('data/kvList', 'WarehouseAndPos')
  },
  data () {
    return {}
  },
  methods: {
    convertData (item) {
      const ret = {
        label: item.name,
        value: item.id,
        children: []
      }
      for (const pos of item.posList) {
        ret.children.push({
          label: pos.name,
          value: pos.id
        })
      }
      return ret
    }
  },
  computed: {
    options () {
      const options = []
      if (this.selectAll) {
        options.push({
          label: '全部',
          value: null
        })
      }
      for (const item of this.$store.state.data.WarehouseAndPos || []) {
        options.push(this.convertData(item))
      }
      return options
    }
  }
}
</script>

<style scoped>
</style>
